import { BOOK_SURGERY_TREATMENT_REQUEST, BOOK_SURGERY_TREATMENT_REQUEST_ERROR, BOOK_SURGERY_TREATMENT_REQUEST_SUCCESS, CLEAR_DATA_SURGERY_TREATMENT, SURGICAL_TREATMENT_REQUEST, SURGICAL_TREATMENT_REQUEST_ERROR, SURGICAL_TREATMENT_REQUEST_SUCCESS } from './Constants';

// userReducer.js
const initialState = {
    loading: false,
    error: null,
};
  
export const planMySurgeryReducer = (state = initialState, action) => {
    switch (action.type) {
    case SURGICAL_TREATMENT_REQUEST:        
        return { ...state,loading: true };
    case SURGICAL_TREATMENT_REQUEST_SUCCESS :                
        return { ...state, treatmentData : action.data, loading: false };
    case SURGICAL_TREATMENT_REQUEST_ERROR :
        return { ...state,loading: false };
    case BOOK_SURGERY_TREATMENT_REQUEST:        
        return { ...state,loading: true };
    case BOOK_SURGERY_TREATMENT_REQUEST_SUCCESS :                
        return { ...state, successData : action.data, loading: false };
    case BOOK_SURGERY_TREATMENT_REQUEST_ERROR :
        return { ...state,loading: false };
    case CLEAR_DATA_SURGERY_TREATMENT :
        return { ...state, successData : null, loading: false };
    default:
        return state;
    }
};
  